<script lang="ts">
  import { toPersianDigits } from '@clinic/money-date';
  import { ReceiptText } from '@lucide/svelte';
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { fa } from '../../../shared/i18n/fa';
  import { FollowUpRow } from '../../../shared/ui';
  import { usePendingCosts } from '../api/inventory-api';

  /** Home: goods received without a purchase price, waiting for one (ADR-053). */
  const org = useOrg();
  const list = usePendingCosts(org.orgId);
  const total = $derived(list.data?.total ?? 0);
</script>

<FollowUpRow
  to={`/o/${org.orgId}/inventory?tab=costs`}
  title={fa.home.costsTitle}
  Icon={ReceiptText}
  attention={total > 0}
  loading={list.isPending}
  error={list.error}
  onRetry={() => void list.refetch()}
  linkLabel={fa.home.costsOpen}
  testid="home-costs"
>
  {#if total === 0}
    <p class="text-text-3">{fa.home.costsNone}</p>
  {:else}
    <p class="tabular-nums">{fa.home.costsPending(toPersianDigits(total))}</p>
  {/if}
</FollowUpRow>
